import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
var CATEGORY_INFIX = 'c';
var EDITO_INFIX = 'e';
var PRODUCT_INFIX = 'p';
var STATIC_INFIX = 's';
var SEARCH_INFIX = 'q';
export { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX };